<template>
  <div class="change-password-page">
    <van-nav-bar
        title="修改登录密码"
        left-text="返回"
        right-text="首页"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
    ></van-nav-bar>

    <div class="header">
      <h2>&nbsp;</h2>
      <p>请设置一个更安全的登录密码</p>
    </div>
    <div style="padding: 24px 16px 40px;">
    <van-form @submit="onSubmit" ref="formRef" class="password-form">
      <!-- 原密码 -->
      <van-field
        v-model="form.oldPassword"
        :type="showNewPassword ? 'text' : 'password'"
        name="oldPassword"
        label="原密码"
        placeholder="请输入当前密码"
        :rules="[{ required: true, message: '请输入原密码' }]"
        autocomplete="current-password"
        left-icon="lock"
        class="form-field"
        :right-icon="showNewPassword ? 'eye' : 'eye-o'"
        @click-right-icon="() => (showNewPassword = !showNewPassword)"   
      />

      <!-- 新密码 -->
      <van-field
        v-model="form.newPassword"
        :type="showConfirmPassword ? 'text' : 'password'"
        name="newPassword"
        label="新密码"
        placeholder="6-20位字母、数字或符号"
        :rules="[
          { required: true, message: '请输入新密码' },
          { pattern: /^.{6,20}$/, message: '密码长度为6-20位' }
        ]"
        autocomplete="new-password"
        left-icon="eye-o"
        @input="checkPasswordStrength"
        class="form-field"
        :right-icon="showConfirmPassword ? 'eye' : 'eye-o'"
        @click-right-icon="() => (showConfirmPassword = !showConfirmPassword)"     
      />

      <!-- 密码强度条 -->
      <div v-if="form.newPassword" class="strength-container">
        <div class="strength-label">密码强度</div>
        <div class="strength-bar">
          <div
            class="strength-fill"
            :class="`strength-${strengthLevel}`"
            :style="{ width: strengthPercent + '%' }"
          ></div>
        </div>
        <div class="strength-text">{{ strengthText }}</div>
      </div>

      <!-- 确认新密码 -->
      <van-field
        v-model="form.confirmPassword"
        :type="showNewPassword2 ? 'text' : 'password'"
        name="confirmPassword"
        label="确认密码"
        placeholder="请再次输入新密码"
        :rules="[
          { required: true, message: '请确认新密码' },
          { validator: validateConfirmPassword, message: '两次密码不一致' }
        ]"
        autocomplete="new-password"
        left-icon="success"
        class="form-field"
        :right-icon="showNewPassword2 ? 'eye' : 'eye-o'"
        @click-right-icon="() => (showNewPassword2 = !showNewPassword2)"             
      />

      <!-- 提交按钮 -->
      <div class="submit-btn-wrapper">
        <van-button
          block
          type="primary"
          native-type="submit"
          :loading="loading"
          loading-text="修改中..."
          class="submit-btn"
        >
          确认修改
        </van-button>
      </div>
    </van-form>
  </div>
  </div>
</template>

<script>
import { Form, Field, Button, Toast } from 'vant';

export default {
  name: 'ChangePassword',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button
  },
  data() {
    return {
      loading: false,
      showNewPassword: false,        // 控制新密码可见性
      showConfirmPassword: false,    // 控制确认密码可见性
      showNewPassword2:false,

      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    };
  },
  computed: {
    // 密码强度等级：0=弱, 1=中, 2=强
    strengthLevel() {
      return this.calculateStrengthLevel();
    },
    strengthPercent() {
      const levels = [30, 60, 100];
      return levels[this.strengthLevel] || 30;
    },
    strengthText() {
      const texts = ['弱', '中', '强'];
      return texts[this.strengthLevel] || '弱';
    }
  },
  methods: {
    validateConfirmPassword(val) {
      return val === this.form.newPassword;
    },

    calculateStrengthLevel() {
      const pwd = this.form.newPassword;
      if (!pwd) return 0;

      let score = 0;
      if (pwd.length >= 8) score += 1;
      if (/[a-z]/.test(pwd)) score += 1;
      if (/[A-Z]/.test(pwd)) score += 1;
      if (/\d/.test(pwd)) score += 1;
      if (/[^a-zA-Z\d]/.test(pwd)) score += 1;

      if (score <= 2) return 0;
      if (score <= 3) return 1;
      return 2;
    },

    checkPasswordStrength() {
      // 仅用于触发 computed 更新
    },

    async onSubmit() {
      this.loading = true;
      try {
        // 模拟请求

        
        let reqData ={
            lysCstUserId:sessionStorage.getItem('lysCstUserId'),
            oldPwd:this.form.newPassword,
            newPwd:this.form.newPassword
        }
        this.$getRequestData20('updateUserLoginPwd', reqData)
        .then(result => {
            if(result.resultCode == '0000'){
                
                    this.$dialog.alert({
                        title: '成功',
                        message: '设置新密码成功',
                        confirmButtonText: '确定',
                        theme: 'round-button'
                    }).then(() => {
                         this.$router.push({ path: '/my/indexPage' })
                    });  

            }else{
                 Toast.fail('修改失败，请重试');
            }

        })

      } catch (error) {
        Toast.fail('修改失败，请重试');
      } finally {
        this.loading = false;
      }
    },
    onClickLeft(){
        history.go(-1);
    },
    onClickRight()
    {
        this.$router.push({ path: '/index/homePage' })
    },     
  }
};
</script>

<style scoped>
::v-deep .van-cell {
  font-size: 16px !important;
}
/* 让右侧眼睛图标颜色更淡 */
::v-deep .van-field__right-icon {
  color: #999;
}
::v-deep .van-field__right-icon:active {
  color: #1989fa;
}

.change-password-page {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4edf9 100%);
  min-height: 100vh;
  box-sizing: border-box;
}

.header {
  text-align: center;
  margin-bottom: 32px;
}

.header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #191a1b;
  margin-bottom: 8px;
}

.header p {
  font-size: 14px;
  color: #666;
}

.password-form {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.form-field {
  margin-bottom: 20px;
}

.form-field::v-deep .van-field__label {
  color: #333;
  font-weight: 500;
}

/* 密码强度样式 */
.strength-container {
  padding: 0 16px 20px;
}

.strength-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}

.strength-bar {
  height: 6px;
  background-color: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
}

.strength-fill {
  height: 100%;
  transition: width 0.3s ease, background-color 0.3s ease;
}

.strength-0 {
  background-color: #ff4444; /* 红 */
}
.strength-1 {
  background-color: #ffaa00; /* 橙 */
}
.strength-2 {
  background-color: #07c160; /* 绿 */
}

.strength-text {
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
}
.strength-0 + .strength-text { color: #ff4444; }
.strength-1 + .strength-text { color: #ffaa00; }
.strength-2 + .strength-text { color: #07c160; }

/* 提交按钮 */
.submit-btn-wrapper {
  margin-top: 42px;
}

.submit-btn {
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 12px;
  background: linear-gradient(90deg, #1989fa, #0d6efd);
  border: none;
}

/* 响应式优化 */
@media (max-width: 375px) {
  .change-password-page {
    padding: 16px 12px 30px;
  }
  .password-form {
    padding: 16px;
  }
}
</style>